import { BaseDecisionTreeViewerApi } from "./base";

export class StateApi extends BaseDecisionTreeViewerApi {
  constructor() {
    super({ baseURL: "/us_states" });
  }
}

let api;

export const useStateApi = () => {
  api ??= new StateApi();

  return {
    all: async () => api.get(),
  };
};
